// Generated by AI on 05/27/2026
import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import * as Sentry from '@sentry/react';
import ErrorFallback from './ErrorFallback';
import logger from '../../services/logger';

// Generated by AI on 05/27/2026
const handleError = (error, errorInfo) => {
    // Log in development
    const isProductionEnv = ENVIRONMENT === 'production';
    if (!isProductionEnv) {
        logger.error(`ErrorBoundary caught an error: ${error.message}, errorInfo: ${JSON.stringify(errorInfo)}`);
    }

    // Send to Sentry
    Sentry.captureException(error, {
        contexts: {
            react: {
                componentStack: errorInfo.componentStack,
            },
        },
    });
};

// Generated by AI on 05/27/2026
const ErrorBoundary = ({ children }) => (
    <ReactErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={handleError}
        onReset={() => { window.location.href = '/'; }}
    >
        {children}
    </ReactErrorBoundary>
);

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
